<script>
export default {
    props: {
        value: {
            type: Object,
            required: false,
            default: () => ({})
        },
        isEditing: {
            type: Boolean,
            default: false
        },
        entity: {
            type: String,
            required: true
        },
        validation: {
            type: Object,
            required: true
        },
        serverErrors: {
            type: Array,
            required: false,
            default: () => []
        }
    },

    data() {
        return {
            [this.entity]: {}
        };
    },

    created() {
        this[this.entity] = { ...this.value };

        this.$watch(this.entity, () => this.$emit('input', this[this.entity]), {
            deep: true
        });
    },

    methods: {
        getError(key) {
            return this.$getValidationErrorMessageHandler.handle(
                this.validation[this.entity],
                this.serverErrors,
                key
            );
        }
    }
};
</script>
